// extracted by mini-css-extract-plugin
module.exports = {"hideAnythingBeneath":"TimelineLeg-module__hideAnythingBeneath___OIjUg","technicalStop":"TimelineLeg-module__technicalStop___CghtN"};